import { render, staticRenderFns } from "./ContentBookmarkApp.vue?vue&type=template&id=7ed13c12&"
import script from "./ContentBookmarkApp.vue?vue&type=script&lang=js&"
export * from "./ContentBookmarkApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports